import request from '../utils/fetch'

export function getHouseOutOrderList (data) {
  return request({
    url: '/house/outorder/getHouseOutOrderList',
    method: 'get',
    requestBody: 'query',
    loading: true,
    params: data
  })
}
export function getHouseOutOrderInfo (data) {
  return request({
    url: '/house/outorder/getHouseOutOrderInfo',
    method: 'get',
    requestBody: 'query',
    loading: true,
    params: data
  })
}
export function sendOutOrder (data) {
  return request({
    url: '/house/outorder/sendOutOrder',
    method: 'post',
    requestBody: 'body',
    loading: true,
    data: data
  })
}







